import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=440a7541&scoped=true&"
import script from "./Lista.vue?vue&type=script&lang=js&"
export * from "./Lista.vue?vue&type=script&lang=js&"
import style1 from "./Lista.vue?vue&type=style&index=1&id=440a7541&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a7541",
  null
  
)

export default component.exports